import {
  Button,
  ButtonGroup,
  Heading,
  Link,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useAuth } from "@clerk/clerk-react";
import { useState } from "react";

import { useOrgsData } from "@/app/data/useOrgsData";
import CenteredLayout from "@/common/components/CenteredLayout";
import OrganizationSwitcher from "@/common/components/OrganizationSwitcher";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { API_URL } from "@/common/utils/env";
import { BillingPortalUrl } from "@reflag/shared/urls";

export default function OrgSuspended() {
  const { signOut } = useAuth();
  const { org } = useEnvironment();
  const [orgSwitcherIsOpen, setOrgSwitcherIsOpen] = useState(false);

  const { data } = useOrgsData();
  const orgs = data?.data ?? [];

  return (
    <CenteredLayout>
      {org ? (
        <VStack spacing={6}>
          <Heading fontSize="2xl">Account suspended</Heading>

          <Text>
            <strong>{org.name}</strong> has been suspended by Reflag.
          </Text>
          <Text>
            Please{" "}
            <Link href={BillingPortalUrl(API_URL, org.id)}>
              subscribe to a plan
            </Link>{" "}
            to re-activate your organization.
          </Text>

          <ButtonGroup>
            {orgs.length > 1}
            <Button
              variant="outline"
              onClick={() => {
                setOrgSwitcherIsOpen(true);
              }}
            >
              Switch to a different organization
            </Button>

            <Button variant="outline" onClick={() => signOut()}>
              Log out
            </Button>
          </ButtonGroup>
          <OrganizationSwitcher
            isOpen={orgSwitcherIsOpen}
            onClose={() => {
              setOrgSwitcherIsOpen(false);
            }}
          />
        </VStack>
      ) : (
        <Spinner />
      )}
    </CenteredLayout>
  );
}
